@if (showBackButton) {
    <ng-container>
        <button type="button" (click)="goBack()" class="btn btn-secondary" style="position: absolute;margin-top:0.5%">Back</button>
    </ng-container>
}
